import * as type from './type';

export const getNotice = (params) => {
  console.log(params,'params234')
  return {
    type: type.GET_NOTICE,
    params,
  };
};

export const getNoticeSuccess = (payload) => {
  return {
    type: type.GET_NOTICE_SUCCESS,
    payload,
  };
};



export const getNoticeDetail = (params) => {
  return {
    type: type.GET_NOTICE_DETAIL,
    params,
  };
};

export const getNoticeDetailSuccess = (payload) => {
  return {
    type: type.GET_NOTICE_DETAIL_SUCCESS,
    payload,
  };
};

export const updateNoticeList = (payload) => {
  console.log(payload, 'payload');
  return {
    type: type.UPDATE_NOTICE_LIST,
    payload,
  };
};
